import { SvgIcon } from '@mui/material';
import { motion } from 'motion/react';
import { forwardRef } from 'react';

import type { AnimatedIconProps, AnimeatableIconRef } from './types';
import { pathVariants } from './types';
import { useAnimatedIcon } from './useAnimatedIcon';

const TicketIcon = forwardRef<AnimeatableIconRef, AnimatedIconProps>(
  ({ size = 28, strokeWidth = 2, titleAccess, color, fontSize }, ref) => {
    const controls = useAnimatedIcon(ref);

    return (
      <SvgIcon
        titleAccess={titleAccess}
        color={color}
        fontSize={fontSize}
        sx={fontSize ? undefined : { width: size, height: size }}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <motion.path
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={0}
            d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
          />
          <motion.path
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={1}
            d="M13 5v2"
          />
          <motion.path
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={2}
            d="M13 17v2"
          />
          <motion.path
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={3}
            d="M13 11v2"
          />
        </svg>
      </SvgIcon>
    );
  }
);

TicketIcon.displayName = 'TicketIcon';

export { TicketIcon };
